import { useEffect, useState } from "react";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useWorkspaceAccounts from "common/datahooks/useWorkspaceAccounts";

export default function useSelectedMinerAccount(isSalesNavigator?: boolean) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { workspaceAccounts } = useWorkspaceAccounts(workspaceId);

  const [minerAccountId, setMinerAccountId] = useState<string>();

  const minerAccount = workspaceAccounts?.find(
    ({ id }) => id === minerAccountId,
  );

  useEffect(() => {
    if (workspaceAccounts?.length) {
      const firstAccount = isSalesNavigator
        ? workspaceAccounts.find(({ sales_navigator }) => sales_navigator)
        : workspaceAccounts[0];

      if (firstAccount) {
        setMinerAccountId(firstAccount.id);
      }
    }
  }, [workspaceAccounts]);

  return { minerAccountId, setMinerAccountId, minerAccount };
}
